<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        {{ popupTitle }}
      </h3>

      <validation-observer ref="warning-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <label for="insurance">Validate date and time:</label>
            <date-range-picker
              ref="picker"
              :locale-data="{
                'firstDay': 1,
                'format': 'DD-MM-YYYY'
              }"
              :class="{ 'w-100': true }"
              :singleDatePicker="false"
              :timePicker="true"
              :showWeekNumbers="false"
              :showDropdowns="true"
              :autoApply="true"
              v-model="dateRange"
              :ranges="false"
              :linkedCalendars="true">
              <template v-slot:input="picker" style="min-width: 350px;">
                <template v-if="picker.startDate === null || (picker.startDate.toString() !== picker.endDate.toString())">
                  {{ picker.startDate | dateStart }} - {{ picker.endDate | dateEnd }}
                </template>
                <template v-if="picker.startDate !== null && picker.startDate.toString() === picker.endDate.toString()">
                  {{ picker.startDate | dateStart }} - not specified
                </template>
              </template>
            </date-range-picker>
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="message"
              v-slot="{ errors }">
              <label for="notes">Message:</label>
              <d-textarea
                v-model="data.message"
                :value.prop="data.message"
                :state="errors.length ? 'invalid' : null"
                :rows="2" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="severity_level"
              v-slot="{ errors }">
              <label for="notes">Severity level:</label>

              <div :class="{ 'mt-1': true, 'is-invalid': errors.length }">
                <d-form-radio
                  inline
                  name="severity"
                  v-model="data.severity_level"
                  :state="errors.length ? 'invalid' : null"
                  value="LOW">
                  Low
                </d-form-radio>
                <d-form-radio
                  inline
                  name="severity"
                  v-model="data.severity_level"
                  :state="errors.length ? 'invalid' : null"
                  value="MEDIUM">
                  Medium
                </d-form-radio>

                <d-form-radio
                  inline
                  name="severity"
                  v-model="data.severity_level"
                  :state="errors.length ? 'invalid' : null"
                  value="HIGH">
                  High
                </d-form-radio>
              </div>

              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import FormUtils from './../../utils/FormUtils';
import DateUtils from './../../utils/DateUtils';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  name: 'WarningPopup',
  components: {
    'date-range-picker': DateRangePicker
  },
  filters: {
    dateStart (input) {
      if (input === null) {
        return ' from ';
      }

      let date = [
        input.getDate(),
        DateUtils.getMonthShortName(input.getMonth() + 1),
        input.getFullYear().toString().substr(2, 2)
      ].map(n => n < 10 ? '0' + n : n).join('');

      let time = [
        input.getHours(),
        input.getMinutes()
      ].map(n => n < 10 ? '0' + n : n).join('');

      return date + ' ' + time;
    },
    dateEnd (input) {
      if (input === null) {
        return ' to ';
      }

      let date = [
        input.getDate(),
        DateUtils.getMonthShortName(input.getMonth() + 1),
        input.getFullYear().toString().substr(2, 2)
      ].map(n => n < 10 ? '0' + n : n).join('');

      let time = [
        input.getHours(),
        input.getMinutes()
      ].map(n => n < 10 ? '0' + n : n).join('');

      return date + ' ' + time;
    }
  },
  computed: {
    popupTitle () {
      if (this.mode === 'add') {
        return 'Add warning';
      }

      return 'Edit warning';
    }
  },
  data () {
    return {
      isVisible: false,
      mode: 'add',
      loading: false,
      data: {
        id: false,
        valid_from: null,
        valid_to: null,
        message: '',
        severity_level: null,
        only_admin: false,
        reference_type: null,
        reference_id: null
      },
      dateRange: {
        startDate: null,
        endDate: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-warning-popup', this.show);
  },
  methods: {
    show (mode, referenceType = false, referenceId = false, warningId = false) {
      this.mode = mode;

      if (mode === 'add') {
        this.loading = false;
        this.data = {
          id: false,
          valid_from: null,
          valid_to: null,
          message: '',
          severity_level: null,
          only_admin: false,
          reference_type: referenceType,
          reference_id: referenceId
        };
        this.dateRange.startDate = null;
        this.dateRange.endDate = null;
      } else {
        this.loading = true;
        this.loadWarningData(warningId);
      }

      setTimeout(() => {
        this.$refs['warning-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    loadWarningData (warningId) {
      FormUtils.loadItemData(this, {
        id: warningId,
        endpointBase: '/warnings/item/',
        instanceFields: ['id', 'message', 'only_admin', 'reference_type', 'reference_id'],
        loadedKey: 'loaded',
        successAction: data => {
          if (data.valid_from !== null) {
            this.dateRange.startDate = this.prepareDateFromString(data.valid_from);
          }

          if (data.valid_to !== null) {
            this.dateRange.endDate = this.prepareDateFromString(data.valid_to);
          } else if (data.valid_to === null && data.valid_from !== null) {
            this.dateRange.endDate = this.prepareDateFromString(data.valid_from);
          }

          this.data.severity_level = data.severity_level;
          this.loading = false;
          this.$refs['warning-form'].reset();
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['warning-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let endpointUrl = '/warnings/store';

      if (this.mode === 'edit') {
        endpointUrl = '/warnings/update/' + this.data.id;
      }

      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.mode === 'add' ? 'Warning added' : 'Warning saved',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the warning. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('warnings-list-reload');
          this.$bus.$emit('calendar-warnings-update');
          this.$bus.$emit('reload-flight-warnings-in-popup');
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let startDate = null;
      let endDate = null;

      if (this.dateRange.startDate !== null) {
        startDate = this.prepareDateString(this.dateRange.startDate);
      }

      if (this.dateRange.startDate !== null && this.dateRange.endDate !== null && this.dateRange.endDate.toString() !== this.dateRange.startDate.toString()) {
        endDate = this.prepareDateString(this.dateRange.endDate);
      }

      let dataToSend = {
        valid_from: startDate,
        valid_to: endDate,
        message: this.data.message,
        severity_level: this.data.severity_level
      };

      if (this.data.reference_type === 'ADMIN') {
        dataToSend.only_admin = true;
      } else {
        dataToSend.only_admin = false;
        dataToSend.reference_type = this.data.reference_type;
        dataToSend.reference_id = this.data.reference_id;
      }

      return dataToSend;
    },
    prepareDateString (input) {
      return [input.getFullYear(), input.getMonth() + 1, input.getDate()].map(n => n < 10 ? '0' + n : n).join('-') + ' ' + [input.getHours(), input.getMinutes()].map(n => n < 10 ? '0' + n : n).join(':');
    },
    prepareDateFromString (input) {
      if (input === null) {
        return null;
      }

      input = input.trim().split(' ');

      if (input.length !== 2) {
        return null;
      }

      let date = input[0].split('-').map(n => parseInt(n, 10));
      let time = input[1].split(':').map(n => parseInt(n, 10));

      return new Date(date[0], date[1] - 1, date[2], time[0], time[1]);
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-warning-popup', this.show);
  }
}
</script>
